import { useState } from "react";
import { Styled } from "components/Styled";
import { Link, PolicyPrivacyContainer, StyledCopyRight } from "./styled";
import { Modal } from "components/modal";
import { PoliticsContent } from "./PoliticsContent";
import { AgreementContent } from "./AgreementContent";

export const General = () => {
  const [modalActive, setModalActive] = useState(false);
  const [policy, setPolicy] = useState("");

  
  const handleOpenModalAgreement = () => {
    setModalActive(!modalActive);
    setPolicy("agreement");
  };

  const handleOpenModalPolitics = () => {
    setModalActive(!modalActive);
    setPolicy("policy");
  };

  return (
    <>
      <StyledCopyRight />
      <PolicyPrivacyContainer>
        <Link onClick={handleOpenModalPolitics}>
          <Styled.PBody2>Політика конфіденційності</Styled.PBody2>
        </Link>
        <Link onClick={handleOpenModalAgreement}>
          <Styled.PBody2>Загальні положення та умови</Styled.PBody2>
        </Link>
        <Modal modalActive={modalActive} setModalActive={setModalActive}>
          {policy === "policy" ? <PoliticsContent /> : <AgreementContent />}
        </Modal>
      </PolicyPrivacyContainer>
    </>
  );
};
